"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Pen.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Pen = function Pen(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 12.01 11.95"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Pen Icon"), _react2.default.createElement("path", {
    className: "pen",
    d: "M7.47 2l2.44 2.44-6.18 6.18-2.44-2.44zm4.3-.59L10.67.32a1.08 1.08 0 0 0-1.53 0l-1 1 2.41 2.48 1.22-1.22a.83.83 0 0 0 0-1.18zM0 11.61a.28.28 0 0 0 .34.33l2.72-.66L.62 8.84zm0 0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Pen;